/**
 * The workspace copy for the active language — the one hook every
 * workspace component reads its strings through.
 */

import { useLanguage } from '../../i18n/language.js';
import { WORKSPACE_COPY, type WorkspaceCopy } from '../copy.js';

export function useWorkspaceCopy(): WorkspaceCopy {
  const { language } = useLanguage();
  return WORKSPACE_COPY[language];
}
